import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const SchoolTypeResource = () => {
  return Vue.resource('school_types{/id}')
}



// WEBPACK FOOTER //
// ./src/api/school_type.js